import React, { useState, useEffect } from 'react';
import LockResetOutlinedIcon from '@mui/icons-material/LockResetOutlined';
import ErrorOutlineRoundedIcon from '@mui/icons-material/ErrorOutlineRounded';
import {
    Box, Button,
    FormControl,
    FormLabel,
    Input,
    Sheet,
    Typography,
    Alert,
    FormHelperText,
    DialogTitle,
    DialogContent,
    Modal,
    ModalDialog,
} from '@mui/joy';
import { TbSquareRoundedNumber1, TbSquareRoundedNumber2, TbSquareRoundedNumber3, TbSquareRoundedNumber4, TbSquareRoundedNumber5, TbXboxX } from "react-icons/tb";
import KeyboardArrowRightRoundedIcon from '@mui/icons-material/KeyboardArrowRightRounded';
import * as apiUtility from "../../config/APIUtils";
import { useNavigate, useParams } from 'react-router-dom';

const passVerificationError = {
    isLengthy: false,
    hasUpper: false,
    hasLower: false,
    hasNumber: false,
    hasSpecChar: false,
    confirmPassword: false
}

export default function LoginAlerts({ show, onHide, data }) {
    const [password, setPassword] = useState('');
    const [processType, setProcessType] = useState('passwordReset');
    const [step1Msg, setStep1Msg] = useState('');
    const [header, setHeader] = useState('');
    
    const [dob, setDob] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const [passwordError, setPasswordError] = useState(passVerificationError);
    const [showPasswordSection, setShowPasswordSection] = useState(0);
    
    const navigate = useNavigate();
    const { home } = useParams() || {};
    const currentHome = home || '';
  

    useEffect(() => {
        let passResetRequired = data?.password ? true : false;
        let existingDob = new Date(data?.dob);

        if (passResetRequired && existingDob.getFullYear() < 1911) {
            setHeader('Action Required: Reset Password and Update Date of Birth');
            setStep1Msg('For your account security, we require you to reset your password and update your date of birth before you can access your profile.');
            setProcessType('both');
        } else if (passResetRequired) {
            setHeader('Action Required: Reset Password');
            setStep1Msg('For your account security, we require you to reset your password before you can access your profile.');
            setProcessType('passwordReset');
        } else if (existingDob.getFullYear() < 1911) {
            setHeader('Action Required: Update Date of Birth');
            setStep1Msg('For your account security, we require you to update your date of birth before you can access your profile.');
            setProcessType('dobChange');
        } else {
            setProcessType('none');
        }
        

        setDob(data?.dob);
        setShowPasswordSection(0);
        setPassword('');
        setConfirmPassword('');
        setError('');
        setPasswordError(passVerificationError);
    }, [show]);

    const handleOnChange = (fieldName, value) => {
        setError('');

        if (fieldName === 'confirmPassword') {
            setConfirmPassword(value);
            setPasswordError({ ...passwordError, confirmPassword: password === value });
        }
        if (fieldName === "password") {
            setPassword(value);
            const isLengthy = value.length >= 8;
            const hasUpper = /[A-Z]/.test(value);
            const hasLower = /[a-z]/.test(value);
            const hasNumber = /[0-9]/.test(value);
            const hasSpecChar = /[@,#,$,%,&,*,!]/.test(value);

            setPasswordError({ ...passwordError, isLengthy, hasLower, hasUpper, hasNumber, hasSpecChar });
        }
    };

    const handleSubmit = async () => {
        setError('');

        if (password !== confirmPassword) {
            setError('Passwords do not match');
            return;
        }

        if (password === "Carepassport@1234") {
            setError('Cannot use default password. Please enter a new password to proceed.');
            return;
        }

        setLoading(true);
        try {
            let apiRequest = apiUtility.apiInputRequest;
            apiRequest.endPoint = "login/reset-default-password";
            apiRequest.data = { "user_id": data?.user_id, "login_id": data?.login_id, "newPassword": password }

            apiUtility.sendAPIDataPOST(apiRequest).then(res => {
                if (res.data.error === 0) {
                    setShowPasswordSection((processType === "dobChange" || processType === "both") ? 2 : 3);
                } else {
                    setError(res.data.msg);
                }
            }).catch((error) => console.error(error));

        } catch (err) {
            setError('Failed to update password. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    const submitDob = async () => {
        setError('');

        if (dob === data?.dob) {
            setError('Please enter the correct date of birth to proceed');
            return;
        }

        if (dob === "" || new Date(dob).getFullYear() < 1900 || new Date(dob) > new Date()) {
            setError('Please enter the correct date of birth to proceed');
            return;
        }

        setLoading(true);
        try {
            let apiRequest = apiUtility.apiInputRequest;
            apiRequest.endPoint = "login/update-default-dob";
            apiRequest.data = { "user_id": data?.user_id, "login_id": data?.login_id, "dob": dob }

            apiUtility.sendAPIDataPOST(apiRequest).then(res => {
                if (res.data.error === 0) {
                    setShowPasswordSection(3);
                } else {
                    setError(res.data.msg);
                }

            }).catch((error) => console.error(error));


        } catch (err) {
            setError('Failed to update date of birth. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    const getPasswordHelperText = () => {
        return (
            <Box component="form" onSubmit={handleSubmit} sx={{ display: 'flex', flexDirection: 'column', gap: 2, minWidth: 400 }}>

                <FormControl>
                    <FormLabel>User Id: {data?.user_id}</FormLabel>
                </FormControl>
                <FormControl>
                    <FormLabel>Username: {data?.login_id}</FormLabel>
                </FormControl>

                <FormControl required>
                    <FormLabel>New Password</FormLabel>
                    <Input
                        type="password"
                        name='password'
                        value={password}
                        onChange={(e) => handleOnChange("password", e.target.value)}
                        placeholder="Enter new password"
                    />
                </FormControl>

                <FormControl required>
                    <FormLabel>Confirm Password</FormLabel>
                    <Input
                        type="password"
                        name='confirmPassword'
                        value={confirmPassword}
                        onChange={(e) => handleOnChange("confirmPassword", e.target.value)}
                        placeholder="Confirm password"
                    />
                </FormControl>

                <FormHelperText sx={{ display: "flex", justifyContent: "flex-start", p: 1, alignContent: "flex-start" }}>
                    <ul>
                        {!passwordError.confirmPassword && (
                            <ol className='text-danger'><TbXboxX /> &nbsp;Password mismatch!</ol>
                        )}
                        <ol className={passwordError.isLengthy ? "text-success" : "text-danger"}><TbSquareRoundedNumber1 /> &nbsp;Min 8 characters </ol>
                        <ol className={passwordError.hasLower ? "text-success" : "text-danger"}><TbSquareRoundedNumber2 /> &nbsp;At least one lower case </ol>
                        <ol className={passwordError.hasUpper ? "text-success" : "text-danger"}><TbSquareRoundedNumber3 /> &nbsp;At least one upper case </ol>
                        <ol className={passwordError.hasNumber ? "text-success" : "text-danger"}><TbSquareRoundedNumber4 /> &nbsp;At least one number </ol>
                        <ol className={passwordError.hasSpecChar ? "text-success" : "text-danger"}><TbSquareRoundedNumber5 /> &nbsp;At least one special character </ol>
                    </ul>
                </FormHelperText>

                <Button variant='solid' color='primary' loading={loading} disabled={Object.values(passwordError).includes(false)} onClick={() => handleSubmit()}>
                    Set Password
                </Button>
                <Button variant='soft' color='danger' onClick={() => onHide()} disabled={loading}>
                    Cancel
                </Button>
            </Box>
        )
    }

    const getDobChangeHelperText = () => {
        //let laterButton = goodByeProcess();
        
        let link = (currentHome)? `/${currentHome}/user/${data?.user_id}` : `/user/${data?.user_id}`
        return (
            <Box component="form" onSubmit={handleSubmit} sx={{ display: 'flex', flexDirection: 'column', gap: 2, minWidth: 400 }}>

                <FormControl>
                    <FormLabel>User Id: {data?.user_id}</FormLabel>
                </FormControl>
                <FormControl>
                    <FormLabel>Username: {data?.login_id}</FormLabel>
                </FormControl>

                <Input
                    type="date"
                    slotProps={{
                        input: {
                            min: '1900-06-07'
                        },
                    }}
                    value={dob}
                    onChange={(e) => setDob(e.target.value)}
                />
                <br></br>

                <Button variant='solid' color='primary' loading={loading} disabled={dob == data?.dob} onClick={() => submitDob()}>
                    Update
                </Button>
                <Button variant='soft' color='danger' onClick={() => (processType == "both")?setShowPasswordSection(3):navigate(link)} >
                    Later
                </Button>
            </Box>
        )
    }

    const goodByeProcess = () => {
        if (processType === "passwordReset" || processType === "both") {
            return (
                <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 2 }}>
                    <LockResetOutlinedIcon color='primary' sx={{ fontSize: "8pc", color: "#016799" }} />
                    {/* <Typography level="h2" sx={{color:"#016799"}}>Password Reset Successful!</Typography> */}
                    <Typography level="body-sm" color="neutral" textAlign="center">
                        Your details has been updated successfully. <strong>Please use your updated password to sign in to your account</strong> and explore the Care Passport platform.
                    </Typography>
                    <Button variant='soft' color='primary' onClick={() => onHide()}>
                        Go to Login
                    </Button>
                </Box>
            )
        } else {
            let link = (currentHome)? `/${currentHome}/user/${data?.user_id}` : `/user/${data?.user_id}`
            return (
                <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 2 }}>
                    <LockResetOutlinedIcon color='primary' sx={{ fontSize: "8pc", color: "#016799" }} />
                    <Typography level="body-sm" color="neutral" textAlign="center">
                        Your date of birth has been updated successfully.
                    </Typography>
                    <Button variant='soft' color='primary' onClick={() => navigate(link)}>
                        View profile
                    </Button>
                </Box>
            )
        }
    }

    return (
        <Modal open={show} onClose={onHide} disableScrollLock={true}>
            <ModalDialog>
                <DialogTitle sx={{ color: "#016799" }}>{header}</DialogTitle>
                <DialogContent dividers sx={{ flex: 1, p: 0 }}>
                    <Sheet
                        sx={{
                            maxWidth: 500,
                            mx: 'auto',
                            my: 4,
                            py: 2,
                            px: 2,
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 2,
                            borderRadius: 'md',
                            overflow: 'auto',

                        }}
                    >
                        {(showPasswordSection === 0) ?
                            <>
                                <Typography level="h3" sx={{ color: "#016799" }}>Hello, {data?.fullName}!</Typography>
                                <Typography level="body-sm" color="neutral">
                                    {step1Msg}
                                </Typography>
                                <Button variant='soft' color='primary' endDecorator={<KeyboardArrowRightRoundedIcon />} onClick={() =>  setShowPasswordSection((processType === "passwordReset" || processType === "both" ? 1 : 2))}>Proceed</Button>
                            </>
                            :

                            (showPasswordSection === 1) ?
                                getPasswordHelperText()
                                :
                                (showPasswordSection === 2) ?
                                    getDobChangeHelperText()
                                    :
                                    goodByeProcess()

                        }
                        {error && (
                            <Alert startDecorator={<ErrorOutlineRoundedIcon />} color="danger">
                                {error}
                            </Alert>
                        )}


                    </Sheet>
                </DialogContent>
            </ModalDialog>
        </Modal>
    );
}